import React from 'react';
import PropTypes from 'prop-types';
import Layout from 'sushiweb/Layout';
import H5 from 'sushiweb/Typography/Heading/H5';
import H6 from 'sushiweb/Typography/Heading/H6';
import { P } from 'sushiweb/Typography/Text';
import { StyledDisabledInput, StyledLayout } from '../../styles';
import {
  DottedLine,
  FundsSummaryText,
  FundsSummaryWrapper,
  InputWrapper,
} from '../../../../../styles';
import {
  formatAmountInRupees,
  formatDateInDateOrdinalFormat,
  getReviewProgramCycleAmount,
  getReviewProgramTopUpInfo,
} from '../../../../../../../helpers';
import { FundsSummaryIcon } from '../../../../../../../components/SVGs/commonSVGs';
import {
  applicableFlowTypes,
  currentFlowTypeEnum,
  cycleTypeEnum,
} from '../../../../../../common/components/constants';
// import { getFormattedEndDate } from '../../../../../../../../helpers';

function VoucherFields({ reviewProgramDetails, currentFlow }) {
  const {
    monthly_amount: amountMonthly = '',
    weekly_amount: amountWeekly = '',
    daily_amount: amountDaily = '',
    period: periodCycle = '-',
    payable_amount: payableAmount = '-',
    total_employees: totalEmployees = '-',
    applicable_days: applicableDays = '-',
    start_date: startDate = '-',
    cycle_type: cycleType = 0,
  } = reviewProgramDetails;

  return (
    <>
      <br />
      <StyledLayout gap={30}>
        <Layout.Item colD={6} colT={4} colM={12}>
          <InputWrapper>
            <StyledDisabledInput
              label='Employees count'
              value={totalEmployees}
              disabled
              showHelperText={false}
            />
          </InputWrapper>
        </Layout.Item>
        <Layout.Item colD={6} colT={4} colM={12}>
          <InputWrapper>
            <StyledDisabledInput
              label='Budget'
              value={getReviewProgramCycleAmount(
                cycleType,
                amountWeekly,
                amountMonthly,
                amountDaily,
              )}
              disabled
              showHelperText={false}
            />
          </InputWrapper>
        </Layout.Item>
        <Layout.Item colD={12} colT={12} colM={12}>
          <InputWrapper>
            <StyledDisabledInput
              label='Plan cycle'
              value={
                cycleType === cycleTypeEnum.DAILY
                  ? 'Daily'
                  : `${periodCycle}\t\t\t\t\t\t\t\t\t\t${applicableDays} Day(s)`
              }
              disabled
              showHelperText={false}
            />
          </InputWrapper>
        </Layout.Item>
        <DottedLine> </DottedLine>
      </StyledLayout>
      <FundsSummaryWrapper>
        <FundsSummaryIcon />
        {currentFlow === currentFlowTypeEnum.FLOW_TYPE_LIMIT ? (
          <FundsSummaryText>
            <H5>
              Plan will start from {formatDateInDateOrdinalFormat(startDate)}
            </H5>
            <P>Usage limits are applied</P>
          </FundsSummaryText>
        ) : (
          <FundsSummaryText>
            <H5>Funds summary</H5>
            <P>
              Updated plan cost is{' '}
              <H6>{formatAmountInRupees(payableAmount)}, </H6> topped-up{' '}
              {getReviewProgramTopUpInfo(startDate, cycleType)}
            </P>
          </FundsSummaryText>
        )}
      </FundsSummaryWrapper>
    </>
  );
}

VoucherFields.propTypes = {
  reviewProgramDetails: PropTypes.objectOf(PropTypes.any).isRequired,
  currentFlow: PropTypes.oneOf(applicableFlowTypes),
};

VoucherFields.defaultProps = {
  currentFlow: currentFlowTypeEnum.FLOW_TYPE_PPI,
};

export default VoucherFields;
